var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tabs control-tag-toggle",class:[
    {
      'is-box': _vm.props.tabStyle === '1',
      'is-toggle': _vm.props.tabStyle === '2',
      'is-toggle is-toggle-rounded': _vm.props.tabStyle === '3',
    },
    _vm.data.staticClass,
    _vm.data.class
  ]},[_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }